<script>
	// NPM Modules
	import { collect } from 'collect.js';
	// Components
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	// Stores
	import ClassificationStore from '@/Stores/Racing/ClassificationStore.js';
	// Constants
	import { BetCategory } from '@/Constants/Bet.js';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let sport;
	export let competitions;

	let loading = false;

	$: sport && getTiersForSport();
	$: tiers = $ClassificationStore.all(); //Store a local list so we dont have to convert the collect to an array for every comp!
	$: competitions = sport && tiers && competitions && collect(competitions);

	/**
	 * Get tiers available to sport, runs on load
	 */
	function getTiersForSport() {
		ClassificationStore.getClassifications(BetCategory.Sport);
	}

	/**
	 * Takes the select box input and updates the comp with the new tier!
	 */
	function updateCompetitionTier(competitionId, tierId) {
		competitions.transform((competition) => {
			if (competition.id == competitionId) {
				competition.classification.id = parseInt(tierId);
			}
			return competition;
		});
	}

	/**
	 * For a given comp push update to the backend!
	 */
	function saveCompetitionTier(competitionId) {
		loading = true;
		const competition = competitions.firstWhere('id', competitionId);
		competition
			.patch({
				classification_id: competition.classification.id
			})
			.then(() => {
				notify({
					type: 'success',
					title: 'Competition tiers',
					message: 'Competition tiers successfully saved',
					timeout: 3
				});
			})
			.catch(() => {
				notify({
					type: 'danger',
					title: 'Competition tiers',
					message: 'Problem saving competition tiers',
					timeout: 5
				});
			})
			.finally(() => {
				loading = false;
			});
	}
</script>

{#if sport}
	<div class="overflow-x-auto rounded">
		<table class="w-full whitespace-nowrap mt-3">
			<thead>
				<tr class="text-xs text-left text-gray-500 uppercase">
					<th class="px-6 pt-3 pb-2 font-medium">Competition</th>
					<th class="px-6 pt-3 pb-2 font-medium">Tier</th>
					<th class="w-px px-6 pt-3 pb-2 font-medium">Action</th>
				</tr>
			</thead>
			<tbody class="bg-white">
				{#each competitions && (competitions.sortBy('name').all() ?? []) as competition (competition.id)}
					<tr class="cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100">
						<td class="px-4 py-1 px-6 border-t">
							<div class="flex items-center">
								<div class="mr-2 font-semibold">{competition.name}</div>
							</div>
						</td>
						<td class="px-4 py-1 px-6 border-t">
							<SelectInput
								className="py-1"
								name="tierId"
								on:change={(evt) => updateCompetitionTier(competition.id, evt.target.value)}
								value={parseInt(competition.classification.id)}
							>
								<option value={null}>No Tier Selected...</option>
								{#each competition && tiers as tier (tier.id)}
									{#if parseInt(tier.id) === parseInt(competition.classification.id)}
										<option value={parseInt(tier.id)} selected>{tier.name}</option>
									{:else}
										<option value={parseInt(tier.id)}>{tier.name}</option>
									{/if}
								{/each}
							</SelectInput>
						</td>
						<td class="w-px px-6 border-t">
							<LoadingButton on:click={() => saveCompetitionTier(competition.id)} className="btn btn-primary" {loading}>
								Save
							</LoadingButton>
						</td>
					</tr>
				{:else}
					<tr>
						<td class="px-6 py-4 text-center border-t" colspan="3">
							No competitions found for {sport.name ?? ''}.
						</td>
					</tr>
				{/each}
			</tbody>
		</table>
	</div>
{/if}
